export default {
	'hide-zero-lines': 'sıfır satırları gizle'
}